import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { WidgetType } from "../Enums/WidgetType";
import { ElementHelper } from "../Helpers/ElementHelper";
import { MultipleFilterModel } from "../Models/MultipleFilterModel";
import { FiltersManager } from "./FiltersManager";

export class PartnerListManager {

    constructor(private containerElement: JQuery) {
    }

    public initialize() {

        let self = this;

        self.loadPartners();
    }

    loadPartners() {

        let self = this;

        var partnersListItems = this.containerElement.find('[data-partners-list]');

        partnersListItems.each((index, element) => {  
            var partnerListElement = $(element);

            let displayType = partnerListElement.data('display-type');
            if (displayType == undefined) {
                displayType = '';
            }

            let blockId = partnerListElement.data('block-id');
            if (blockId == undefined) {
                blockId = '';
            }
            partnerListElement.html('<div class="btn-spinner"></div>');

            $.post(`/partner/partnerslist`,
            {
                'displayType': displayType,
                'blockId' : blockId,
                "__RequestVerificationToken": (window as any).getToken()
            },
            function(data){
                partnerListElement.html(data.view);

                Swiper.use([Navigation, Pagination, Autoplay]);

                partnerListElement.find('.partner-swiper').each((index, element) => {
                    var amountSlides = +$(element).data('amount-slides');
                    var autoplay : boolean = $(element).data('autoplay');

                    const partnerSwiper = new Swiper(element,
                    {
                        // Optional parameters
                        direction: 'horizontal',
                        loop: autoplay,
                        slidesPerView: amountSlides <= 3 ? amountSlides : "auto", 
                        centeredSlides: amountSlides <= 3 ? false : true, 
                        spaceBetween: 16,
                        autoplay: autoplay == true ? {
                            delay: 5000
                        } : false,
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                                initialSlide: 1
                                //loop: true,
                            },
                            576: {
                                slidesPerView: 2,
                                initialSlide: 1
                            },
                            992: {
                                slidesPerView: amountSlides <= 3 ? amountSlides : "auto",
                                initialSlide: amountSlides <= 3 ? 1 : Math.floor(amountSlides / 2)
                            },
                            1200: {
                                slidesPerView: amountSlides <= 3 ? amountSlides : "auto",
                                initialSlide: amountSlides <= 3 ? 1 : Math.floor(amountSlides / 2)
                            },
                        },
                        // Navigation arrows
                        navigation: {
                            nextEl: partnerListElement.find('.swiper-button-next')[0],
                            prevEl: partnerListElement.find('.swiper-button-prev')[0],
                        },
                    });
                });
            });
        })  
    }
}